import { Type } from "js-yaml";
class ParsedTr {
  key;
  constructor(key) {
    this.key = key;
  }
}
const TrTag = new Type("!tr", {
  kind: "scalar",
  resolve: (data) => data !== null && typeof data === "string",
  construct: (data) => new ParsedTr(data),
  instanceOf: ParsedTr,
  represent: (data) => data.key
});
export {
  ParsedTr,
  TrTag
};
